/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { smartphoneWirelessOffblack } from "../assets/smartphone-wireless-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSmartphoneWirelessOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={smartphoneWirelessOffblack.svg} />
);

IllustrativeIconSmartphoneWirelessOffblack.displayName = "IllustrativeIconSmartphoneWirelessOffblack";
